import React from "react";
import { Container, Image } from "react-bootstrap";
import { CONTACT_US_BUTTON, HEADING_DESCRIPTION, HEADING_TITLE } from "../Contexts/config";

export const HeadingSecion = ({lang}) => {

    return (
        <Container>
            <div className="d-sm-flex align-items-center justify-content-between vh-100">
                <div>
                    <h1 className="theme-yellow-color display-3">{HEADING_TITLE[lang]}</h1>
                    <p className="lead my-5">{HEADING_DESCRIPTION[lang]}</p>
                    <a href="#contacts" className="contact-us-button">{CONTACT_US_BUTTON[lang]}</a>
                </div>
                <Image className="col-md-7" fluid src="assets/lady-justice.png" alt="" />
            </div>
        </Container>
    );
}